import React from 'react';

import './ZeroSizeCenterer.css';

export default function({children}) {
    return <div className="ZeroSizeCenterer">
        <div>{children}</div>
    </div>
}


// WEBPACK FOOTER //
// ./src/ZeroSizeCenterer.js